import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getTurma = async () => {
  const url = API_CONSTANT_MAP.turma;
  return requestApi.get(url);
};

export const postTurma = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.turma, payload);
};

export const getTurmaById = async (id: string) => {
  const url = `${API_CONSTANT_MAP.turma}/${id}`;
  return requestApi.get(url);
};
